import { makeAutoObservable } from 'mobx';

export class AmusementParkTicketDataStore {
  amusementTicketsSearchFilterExpandedKeys: Record<string, string[]> | null = null;

  constructor() {
    makeAutoObservable(this);
  }

  setAmusementTicketsSearchFilterExpandedKeys = (payload: Record<string, string[]> | null) => {
    this.amusementTicketsSearchFilterExpandedKeys = payload;
  };
}

const amusementParkTicketDataStore = new AmusementParkTicketDataStore();

export default amusementParkTicketDataStore;
